import React from "react"
import CTA from "../components/cta"
import tweetData from "../data/tweets.json"
import { getRandom } from "../helpers/arrays"

export default function SiteFooterTwitter({ path }) {
  const tweets = tweetData.filter(obj => {
    return obj.path === path
  })

  const tweet = tweets.length >= 1 ? getRandom(tweets) : getRandom(tweetData)

  return (
    <li className="site-footer__twitter">
      <header>
        <h3 className="title--quaternary">Twitter Highlights</h3>
        <div className="title--micro title--light title--uppercase">
          <a
            href={`https://twitter.com/${tweet.account}`}
            target="_blank"
            rel="noreferrer"
          >
            @{tweet.account}
            <span className="site-footer__twitter__date">{tweet.date}</span>
          </a>
        </div>
      </header>
      <p dangerouslySetInnerHTML={{ __html: tweet.content }} />
      <CTA
        type="secondary"
        href={tweet.url}
        text="Follow Us"
        targetBlank="true"
      />
    </li>
  )
}
